import { DrawerFilterProvider } from '@hapvida/hapvida-core-components';

import useDeviceBreakpoints from 'hooks/useDeviceBreakpoints';

import { CoparticipationPreviewReportLayout } from './layout';
import { CoparticipationPreviewReportLayoutMobile } from './mobile/layoutMobile';

export function CoparticipationPreviewReportPage() {
  const { isDesktop } = useDeviceBreakpoints();

  return (
    <DrawerFilterProvider>
      {isDesktop ? (
        <CoparticipationPreviewReportLayout />
      ) : (
        <CoparticipationPreviewReportLayoutMobile />
      )}
    </DrawerFilterProvider>
  );
}
